'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = surveyReducer;

var _immutable = require('immutable');

var _SurveyActionTypes = require('../actionTypes/SurveyActionTypes');

var INITIAL_STATE = new _immutable.Map();

function surveyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _SurveyActionTypes.UPDATE_COMMITTED_SURVEY:
      return state.merge(payload);
    default:
      return state;
  }
}
module.exports = exports['default'];